 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLEPAGE from '@/components/title-page'
 import CONTENTS from '@/components/contents'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import PROLOGUE from '@/components/prologue'
 import CHAPTER001 from '@/components/chapter-001'
 import CHAPTER002 from '@/components/chapter-002'
 import CHAPTER003 from '@/components/chapter-003'
 import CHAPTER004 from '@/components/chapter-004'
 import CHAPTER005 from '@/components/chapter-005'
 import CHAPTER006 from '@/components/chapter-006'
 import CHAPTER007 from '@/components/chapter-007'
 import CHAPTER008 from '@/components/chapter-008'
 import CHAPTER009 from '@/components/chapter-009'
 import CHAPTER010 from '@/components/chapter-010'
 import CHAPTER011 from '@/components/chapter-011'
 import CHAPTER012 from '@/components/chapter-012'
 import CHAPTER013 from '@/components/chapter-013'
 import CHAPTER014 from '@/components/chapter-014'
 import CHAPTER015 from '@/components/chapter-015'
 import CHAPTER016 from '@/components/chapter-016'
 import CHAPTER017 from '@/components/chapter-017'
 import CHAPTER018 from '@/components/chapter-018'
 import CHAPTER019 from '@/components/chapter-019'
 import CHAPTER020 from '@/components/chapter-020'
 import CHAPTER021 from '@/components/chapter-021'
 import CHAPTER022 from '@/components/chapter-022'
 import CHAPTER023 from '@/components/chapter-023'
 import CHAPTER024 from '@/components/chapter-024'
 import CHAPTER025 from '@/components/chapter-025'
 import CHAPTER026 from '@/components/chapter-026'
 import CHAPTER027 from '@/components/chapter-027'
 import CHAPTER028 from '@/components/chapter-028'
 import EPILOGUE from '@/components/epilogue'
 import ABOUTTHEQUEENSOFTHECASTLESERIES from '@/components/about-the-queens-of-the-castle-series'
 import UNTITLED80DAYSOFPLEASURE from '@/components/untitled-80-days-of-pleasure'
 import ABOUTTHEAUTHOR from '@/components/about-the-author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/title-page",
 			"name" : "title-page",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/prologue",
 			"name" : "prologue",
 			"component" : PROLOGUE
 		},
 		{
 			"path" : "/chapter-001",
 			"name" : "chapter-001",
 			"component" : CHAPTER001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js